export default "__VITE_ASSET__BGMrklmO__"